<template>
  <div>
    <div class="gc-footer-scan-barcode">
      <!-- <img src="images/products/14.png" class="dx-icon" /> -->
      <i :class="iconClass"></i>
      <span class="gc-footer-label">{{labelText}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "menu"
    },
    labelText: {
      type: String,
      default: ""
    }
  },
  computed: {
    iconClass() {
      return "dx-icon dx-icon-" + this.icon;
    }
  }
};
</script>

<style lang="scss">
.gc-footer-scan-barcode {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2em;
  padding: 10px 20px;
  background: #fff;

  .dx-icon {
    margin: 0 5px;
  }

  .gc-footer-label {
    margin-left: 15px;
    vertical-align: middle;
  }
}
</style>